module.exports = __webpack_public_path__ + "img/fi-rr-fingerprint.61d6335b.svg";